import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { lightTheme } from '@sketch/global-styles';

const COLORS_BY_COLOR_PROP = {
    teal: {
        textColor: '#36AC91',
        backgroundColor: '#ECFBF7',
    },
    orange: {
        textColor: '#c85000',
        backgroundColor: '#FEEFE5',
    },
    indigo: {
        textColor: '#6236ff',
        backgroundColor: '#EFEAFF',
    },
    gray: {
        textColor: lightTheme.colors.foreground.secondary.C,
        backgroundColor: '#F0F0F0',
    },
    none: {
        textColor: 'none',
        backgroundColor: 'none',
    },
};
const getColor = ({ $variant, theme }) => {
    switch ($variant.kind) {
        case 'primary':
            return theme.colors.foreground.primary.A;
        case 'secondary':
            return theme.colors.foreground.secondary.B;
        case 'special':
            return $variant.textTint;
        case 'error':
            return theme.colors.foreground.primary.A;
    }
};
const getBackground = ({ $variant, theme }) => {
    switch ($variant.kind) {
        case 'primary':
            return theme.colors.sketch.A;
        case 'secondary':
            return theme.colors.background.tertiary.B;
        case 'special':
            return $variant.background;
        case 'error':
            return theme.colors.state.negative.A;
    }
};
const StyledPill = styled.span `
  height: 18px;
  display: inline-flex;
  align-items: center;
  text-transform: capitalize;

  font-size: ${({ theme }) => theme.fontSizes.B};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 18px; /* stylelint-disable-line scales/line-height */
  white-space: nowrap;

  padding: 0px 8px;
  border-radius: ${({ theme }) => theme.radii.xxlarge};

  color: ${props => getColor(props)};
  background: ${props => getBackground(props)};
`;
const PillUnstyled = (_a) => {
    var { variant = { kind: 'primary' }, children, className } = _a, props = __rest(_a, ["variant", "children", "className"]);
    return (jsx(StyledPill, Object.assign({ className: className, "$variant": variant }, props, { children: children })));
};
const Pill = styled(PillUnstyled) ``;

export { Pill };
